module.exports = __webpack_public_path__ + "img/fa-solid-900.c2801fb4.svg";